import Vue from 'vue';
export default Vue.extend({
    props: {
        variant: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        loadingVariant: {
            type: String,
            default: 'light',
        },
    },
});
